<div class="drive-sidebar">
  <nz-spin [nzSpinning]="loading">
    <div *ngIf="sidebarError" class="drive-sidebar-error">
      <span>{{ sidebarError }}</span>
      <button nz-button nzType="link" (click)="retryCategory.emit()">重试</button>
    </div>
    <nz-tree
      *ngIf="!sidebarError"
      [nzData]="treeNodes"
      nzBlockNode
      nzNoAnimation
      [nzExpandedKeys]="internalExpandedKeys"
      [nzSelectedKeys]="selectedKeys"
      (nzExpandChange)="onExpandChange($event)"
      (nzClick)="onTreeClick($event)"
    ></nz-tree>
  </nz-spin>
</div>
